import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRequestDecorator } from '../../core/triggerbee/http.request.decorator';
import { TriggerbeeApi } from '../../core/triggerbee/triggerbee-api.enum';

@Injectable({
  providedIn: 'root',
})
export class BugReportService {
  constructor(private http: HttpRequestDecorator) {}

  submitBugReport(formData: FormData): Observable<any> {
    const url = this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/admin/bugreports`;
    return this.http.upload(url, formData);
  }
}
